// extracted by mini-css-extract-plugin
export default {"secondaryButton":"SecondaryButton_secondaryButton__R8B+X","blackText":"SecondaryButton_blackText__jHmfa","disabled":"SecondaryButton_disabled__hVg2N"};